module.exports = __webpack_public_path__ + "img/excesoVelocidadFlota.552998d6.svg";